import React, { Component } from 'react';
import {TabView,Tab} from '@react/react-spectrum/TabView';
import ApprovalComponent from '../approval-component/ApprovalComponent';
import i18n from '../../i18n';
import {withTranslation } from 'react-i18next';
import Loader from "../Common/Loader";
import NoRecords from "../Common/NoRecords";
import {connect} from 'react-redux';
import {getApprovalFlows,setApiStatus,setSelectedTab,getApprovalList} from '../../actions/ApprovalListActions';
import _ from 'lodash';

export class ApprovalList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            context:'APPROVAL_LIST',
            view_orientation : 'vertical'
        };
        this.onSelect = this.onSelect.bind(this);
        this.renderTab = this.renderTab.bind(this);
    }

    componentDidMount() {
        var _self = this;
        _self.customerGuid = _.has(_self.props.userDetails,'userId') ? _self.props.userDetails.userId : '';
        if(_self.customerGuid !== ''){
            _self.props.getApprovalFlows(_self.customerGuid);
        }
        if(document.body.clientWidth < 767) {
            this.setState({view_orientation : 'horizontal'})
        }
    }

    onSelect(e){
        this.props.setSelectedWorkFlowTab(this.props.sideNavs[e].id);
        this.props.getApprovalList(this.props.sideNavs[e].id);
    }

    renderTab(){
        let SideTabs = '';
        SideTabs = this.props.sideNavs.map((obj) =>
            <Tab key={obj.id} label={i18n.t(obj.id+'.approvalSideNav.title')} data-am-id="workflowTabs" selected={obj.id === this.props.selectedTab}>
                {this.props.approvalList && <ApprovalComponent approvalList={this.props.approvalList} context={this.state.context}/> }
            </Tab>
        );
        return SideTabs;
    }

    renderTabView(){
        return(
        <div className="TableContainer" data-am-id="approvalContainer">
            <div className="approval-list-content">
                <div>
                    <TabView orientation={this.state.view_orientation} onSelect={this.onSelect}>
                        {this.renderTab()}
                    </TabView>
                </div>
            </div>
        </div>
        )
    }

    renderLoading(){
        return (<Loader loaderSize="M"/>);
    }

    renderNoRecords(){
        return (<NoRecords message="noApprovalListMessage"/>);
    }

    render() {

        let isListValid = (!_.isUndefined(this.props.approvalList) && this.props.approvalList.length && this.props.sideNavs.length>0);

        return this.props.apiStatus ? this.renderLoading() : (isListValid ? (this.renderTabView()) : this.renderNoRecords());
    }
}

const mapStateToProps = (state)=>{
    return{
        selectedTab:state.ApprovalListReducer.selectedTab,
        sideNavs:state.ApprovalListReducer.sideNavs,
        apiStatus:state.ApprovalListReducer.apiStatus,
        userAccessToken:state.AuthReducer.userAccessToken,
        userDetails:state.AuthReducer.userInfo,
        approvalId:state.ApprovalDetailReducer.approvalId,
        approvalList : state.ApprovalListReducer.approvalList
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        getApprovalFlows : (customerGuid) =>{dispatch(getApprovalFlows(customerGuid))},
        setApiStatus : (flag) => dispatch(setApiStatus(flag)),
        setSelectedWorkFlowTab : (id) => dispatch(setSelectedTab(id)),
        getApprovalList : (flowId) =>{dispatch(getApprovalList(flowId))}
    }
};


export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ApprovalList));
